import { V1_REQUEST_SEAT_TRADE_SEARCH_RESULTS } from '../../actions/seatTrade/v1requestSeatTradeSearchResults'
import { V1_RECEIVE_SEAT_TRADE_SEARCH_RESULTS } from '../../actions/seatTrade/v1receiveSeatTradeSearchResults'
import { V1_RECEIVE_SEAT_TRADE } from '../../actions/seatTrade/v1receiveSeatTrade'
import { V1_REQUEST_SEAT_TRADE } from '../../actions/seatTrade/v1requestSeatTrade'
import { V1_ADD_SEAT_TRADE_NOTIFICATIONS } from '../../actions/seatTrade/v1addSeatTradeNotification'
import { V1_CLEAR_SEAT_TRADE_NOTIFICATIONS } from '../../actions/seatTrade/v1clearSeatTradeNotifications'
import { V1_REMOVE_SEAT_TRADE_NOTIFICATION } from '../../actions/seatTrade/v1removeSeatTradeNotification'
import { V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE } from '../../actions/users/v1setUserHasCustomTourOperatorOverwrite'

export const initialState = {
  isFetching: false,
  items: [],
  isRequestCompleted: false,
  seatsAreBeingTraded: false,
  errors: [],
  notifications: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE:
      return {
        ...state,
        errors: [],
        notifications: [],
      }
    case V1_REQUEST_SEAT_TRADE_SEARCH_RESULTS:
      return {
        ...state,
        errors: [],
        notifications: [],
        isFetching: true,
        isRequestCompleted: false,
      }
    case V1_RECEIVE_SEAT_TRADE_SEARCH_RESULTS:
      return {
        ...state,
        isFetching: false,
        items: action.data,
        isRequestCompleted: true,
      }
    case V1_REQUEST_SEAT_TRADE:
      return {
        ...state,
        errors: [],
        notifications: [],
        seatsAreBeingTraded: true,
        isRequestCompleted: false,
      }
    case V1_RECEIVE_SEAT_TRADE:
      const flightsWithSeatTrade = action.data.seatTrades.map(
        seatTrade => seatTrade.flightId
      )

      return {
        ...state,
        isFetching: false,
        isRequestCompleted: true,
        seatsAreBeingTraded: false,
        items: [...state.items].map(seatTrade => {
          const { seatTrades = [] } = action.data

          if (!flightsWithSeatTrade.includes(seatTrade.flightId))
            return seatTrade

          return {
            ...seatTrade,
            availableSeatCount: seatTrades.find(
              responseSeatTrade =>
                responseSeatTrade.flightId === seatTrade.flightId
            ).availableSeatCount,
          }
        }),
        errors: action.data.errors,
      }
    case V1_ADD_SEAT_TRADE_NOTIFICATIONS:
      return {
        ...state,
        notifications: [...state.notifications, ...action.data],
      }
    case V1_REMOVE_SEAT_TRADE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          notification => notification.message !== action.data
        ),
      }
    case V1_CLEAR_SEAT_TRADE_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      }
    default:
      return state
  }
}
